<template>
  <dd-button
    v-if="$permissions.isAdminOrOwner"
    :size="size"
    :color="ColorAssistant.MailboxColor"
    new-icon
    @click="goToCreateMailbox()"
  ><i class="ddi ddi-mailbox" />&nbsp;<span>New Mailbox</span></dd-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import RouteAssistant from '@/helpers/route-assistant'
import AppSumoAssistant from '@/helpers/appsumo-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Only displays for admin/owners on tablet/desktop */
export default defineComponent({
  name: 'NewMailboxButton',

  props: {
    size: {
      type: String,
      default: 'large',
    },
    workflowId: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      RouteAssistant,
      ColorAssistant,
    }
  },

  methods: {
    async goToCreateMailbox() {
      if (
        await AppSumoAssistant.isUnderMailboxLimit(
          this.$router,
          this.$permissions,
        )
      ) {
        if (this.workflowId) {
          RouteAssistant.goToCreateMailbox(
            this.$router,
            this.$route.params.accountId,
            this.workflowId,
          )
        } else {
          RouteAssistant.goToCreateMailbox(
            this.$router,
            this.$route.params.accountId,
          )
        }
      }
    },
  },
})
</script>
